/** @format */

import { api } from 'utility';
import axios from 'axios';
import { getServiceSetUrl } from 'URLs';
const { CancelToken } = axios; 
let source;

export function getServiceSet(params) {
  if (source) {
    source.cancel();
  }

  source = CancelToken.source();

  const res = api
    .get(getServiceSetUrl(), {
      params,
      cancelToken: source.token,
    })
    .then((res) => res.data);

  return res;
}
